import { render, staticRenderFns } from "./TiktokRanking.vue?vue&type=template&id=79d6fe9d&scoped=true"
import script from "./TiktokRanking.vue?vue&type=script&lang=js"
export * from "./TiktokRanking.vue?vue&type=script&lang=js"
import style0 from "./TiktokRanking.vue?vue&type=style&index=0&id=79d6fe9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d6fe9d",
  null
  
)

export default component.exports